$(".cc-new-order__block:not(:first-of-type)").hide();
$(".cc-new-order__block-next").on("click", function () {
	$(this).closest(".cc-new-order__block").hide();
	$(this).closest(".cc-new-order__block").next(".cc-new-order__block").fadeIn();

	vform.applyEvents($(".cc-new-order__block-main"));
});

$(".cc-new-order__block-back").on("click", function () {
	$(this).closest(".cc-new-order__block").hide();
	$(this).closest(".cc-new-order__block").prev(".cc-new-order__block").fadeIn();

	vform.applyEvents($(".cc-new-order__block-main"));
});